<template>
  <div class="agreementBody">
    <Header />
    <div class="agreementMain">
      <div class="userAgreement">
        <h1>豸信CA数字证书服务协议</h1>
        <p>
          本协议由山东豸信认证服务有限公司（以下简称“豸信CA”）与电子签名认证证书订户（以下简称“订户”“用户”或“您”）签署，具有合同效力。豸信CA是依法取得电子认证服务许可的电子认证服务机构，为订户提供证书申请、审核、签发和管理等电子认证服务。为明确双方权利和义务，双方就电子签名认证证书的申请和使用等事项达成本协议。您在申请使用豸信CA签发的电子签名认证证书前，应先阅读并同意本协议。
        </p>
        <p>本协议仅适用于豸信CA签发的电子签名认证证书。本协议所称“数字证书”或“证书”均指电子签名认证证书；非电子签名认证证书不适用本协议。</p>
        <h2>第一条 定义</h2>
        <p>1. 电子签名认证证书：由依据《中华人民共和国电子签名法》设立的电子认证服务机构签发的，可证实电子签名人与电子签名制作数据有联系的数字证书。按照证书主体类型和业务风险等级，分为个人高等级电子签名认证证书、个人基础级电子签名认证证书、机构高等级电子签名认证证书和机构基础级电子签名认证证书。</p>
        <p>2. 电子认证服务机构（CA）：取得电子认证服务许可证，为需要第三方认证的电子签名签发电子签名认证证书，并为有关各方提供真实性、可靠性验证的实体。</p>
        <p>3. 订户：被颁发给一张证书的证书主体，在不同阶段也称为证书申请人、证书持有人。订户包括自然人、法人、非法人组织及其他组织。本协议中的“用户”或“您”均指订户。</p>
        <p>4. 受托人：根据订户的有效授权，在授权范围内代为办理证书及私钥的申请、接受、保管、使用、更新、撤销及其他相关事项的自然人、法人、非法人组织或其他组织。机构订户可以通过法定代表人或有效授权的受托人办理相关事项。</p>
        <p>5. 证书等级：高等级电子签名认证证书适用于涉及生命健康、财产权益等高风险场景；基础级电子签名认证证书适用于除高等级证书规定场景外的其他电子签名场景。</p>
        <p>6. 签名私钥：非对称密码算法中只能由拥有者使用的不公开密钥，属于《中华人民共和国电子签名法》中电子签名制作数据的一种实现形式，用于制作电子签名。本协议中的“私钥”均指签名私钥。</p>
        <p>7. 激活数据：用于使密码模块进入可操作状态的数据，可为口令、生物特征等。</p>
        <p>8. 电子签名应用平台运营方：提供证书申请、使用及管理入口的电子签名应用平台运营主体。</p>
        <p>9. 依赖方：基于对电子签名认证证书或者电子签名的信赖从事有关活动的人。</p>
        <p>10. 电子认证业务规则（CPS）：豸信CA在官网<a href="https://www.zxca.cn">（www.zxca.cn）</a>公示的《电子认证业务规则》，规定豸信CA在证书申请、签发、使用、更新、撤销等电子认证服务过程中所遵循的业务规则。</p>
        <h2>第二条 申请前告知及确认</h2>
        <p>豸信CA在受理电子签名认证证书申请前向您告知以下事项。您接受本协议，即确认已充分阅读、知悉并同意以下内容：</p>
        <p>1. 订户的权利和义务。您有权按照本协议及CPS申请、使用、查询、续期、更新及申请撤销证书；您应提供真实、完整、准确的申请信息及证明材料，配合身份查验和申请意愿确认，遵守证书用途、等级及使用限制，并履行本协议约定的其他义务。</p>
        <p>2. 服务收费项目和标准。证书服务一般不由豸信CA直接向订户收费；需向订户收费的，收费项目和标准在订户申请相关服务前另行约定。未与豸信CA约定证书服务费的，订户无须支付证书费用。</p>
        <p>3. 电子签名认证证书及电子签名的使用条件。您应在证书有效期内、证书未被撤销且符合证书载明用途及适用等级的情况下使用。涉及生命健康、财产权益等高风险活动，或者CPS规定应使用高等级证书的其他场景，不得使用基础级电子签名认证证书。法律、行政法规或CPS规定不适用电子签名的事项，不得使用证书实施电子签名。非电子签名认证证书不得用于电子签名。</p>
        <p>4. 信息安全保障措施。豸信CA按照CPS对受托保管的签名私钥加密存储，并对认证档案采取访问控制、操作记录等安全保障措施。您应妥善保护自行持有的签名私钥及激活数据、用于身份验证和签名授权的密码、验证码等信息，并确保使用环境安全。涉及个人信息的保护措施，见豸信CA官网公示的《隐私政策》。</p>
        <p>5. 豸信CA与订户的责任划分。豸信CA按照法律法规、本协议及CPS提供电子认证服务，并承担相应的电子认证服务责任；订户对申请资料的真实性、受托人的授权办理、证书及签名私钥的使用、相关密码的保管以及违反本协议的行为承担相应责任。</p>
        <p>6. 签名私钥的保存方式及安全要求。使用UKey等硬件介质的，签名私钥由订户自行持有、保管；除使用硬件介质的情形外，您同意并授权豸信CA生成、托管您的签名私钥。订户应妥善保管自行持有的签名私钥及激活数据、用于身份验证和签名授权的密码、验证码等，不得泄露或交付无权人员。</p>
        <p>7. 禁止用途。您不得将证书用于任何违法违规、违背公序良俗的用途，不得利用证书从事侵害国家利益、社会公共利益及第三方合法权益的活动；违反上述要求的，由您承担相应责任，豸信CA有权依照CPS及本协议撤销相关证书。</p>
        <h2>第三条 声明及申请确认</h2>
        <p>1. 您知悉申请并使用电子签名认证证书实施电子签名签署合同或其他文件、单证等文书的，即应视为同意使用电子签名及数据电文，并认可电子签名与手写签名或者盖章具有同等的法律效力。</p>
        <p>2. 您应在申请电子签名认证证书前仔细阅读本协议及豸信CA官网公示的CPS。若您不同意本协议或CPS的任意内容，或者无法准确理解豸信CA对条款的解释，请勿接受本协议或申请使用证书。您通过网络界面点击同意、回填短信验证码确认、使用电子签名签署或者书面签署等各类方式接受本协议，即表示您已充分阅读、理解、知悉并同意遵守本协议及CPS的全部内容，承诺遵守适用的法律、法规、规章及其他政府规范性文件；违反上述要求造成的法律后果，由您以自身名义承担。</p>
        <p>3. 您接受本协议，即表示同意向豸信CA申请电子签名认证证书。您提交具体证书申请时，应核对申请页面或申请材料载明的申请主体、证书等级等信息；提交申请即确认该等信息符合您的申请意愿。</p>
        <p>4. 您同意豸信CA为身份查验、证书申请及管理、签名私钥使用及管理、签名验证、存证出证和相关争议处理，按照实际认证方式收集、核验、存储和使用包括您及相关法定代表人、受托人的认证资料，包括但不限于人脸等生物识别信息、原始照片、音视频、身份证件信息、金融账户信息等敏感个人信息，以及核验结果、身份查验过程和意愿确认记录等。涉及第三方个人信息的，您承诺已取得相关主体的授权同意。您同意豸信CA为相应用途，将上述认证资料传输或提供给身份查验数据及技术支持提供方（含人脸识别技术提供方）、电子签名应用平台运营方、数字证书依赖方，以及深圳法大大网络科技有限公司等存证出证及争议解决机构。豸信CA依法保存与认证有关的信息至少至相关证书失效后五年；法律、行政法规另有规定的，从其规定。具体个人信息处理及权利行使规则，详见豸信CA官网公示的《隐私政策》。</p>
        <p>5. 若不同意本协议全部或部分条款，请勿申请使用豸信CA的证书。您完成证书下载或初次使用，亦表明您同意接受并愿意遵守本协议的全部条款。</p>
        <p>6. 您作为依赖方，基于对豸信CA签发的电子签名认证证书或相关电子签名的信赖从事有关活动时，确认接受并遵守豸信CA官网公示的《豸信CA依赖方协议》，并履行相应的依赖方义务。</p>
        <h2>第四条 申请与接受</h2>
        <p>1. 除使用硬件介质的情形外，您同意并授权豸信CA按照CPS为您生成签名密钥对，并受托保管相应签名私钥；使用硬件介质的，签名私钥由您自行持有和保管。您通过身份验证和签名授权方式，控制签名私钥的激活及使用。</p>
        <p>2. 订户应遵循诚实守信原则，在申请证书时提供真实、完整、准确的信息及证明材料，并在信息或资料发生变化时及时通知豸信CA。如因订户故意或过失提供的信息不真实、不完整、不准确，或信息变化后未及时通知，导致证书签发错误或造成相关各方损失的，由订户承担相应责任。由受托人办理的，订户应提供符合CPS要求的有效授权证明，并配合豸信CA完成订户及受托人的身份查验；订户对受托人在授权范围内的申请、协议签署及使用行为承担相应法律后果。</p>
        <p>3. 豸信CA应积极响应订户发出的证书申请请求，及时对订户申请数字证书时提交的信息进行审核。如果由于设备或网络故障而导致签发数字证书错误、延迟、中断或者无法签发，豸信CA 仅提供再次签发服务，不承担任何赔偿责任。</p>
        <p>4. 订户同意电子签名应用平台运营方接收、保管证书文件，并同意通过申请页面、认证应用工具或电子签名应用平台运营方提供的入口获知证书申请处理结果，豸信CA无需另行重复通知。订户取得证书时，应及时核对证书所载主体信息等是否准确；发现错误的，应及时通知豸信CA。订户使用证书即视为接受证书，并承担该证书使用的责任和后果。</p>
        <h2>第五条 使用</h2>
        <p>1. 证书用于其载明用途范围内的电子签名及相关身份识别、数字签名验证。订户应按照证书载明用途、申请时确认的证书主体类型和等级及实际业务场景使用证书。涉及生命健康、财产权益等高风险活动，或者CPS规定应使用高等级证书的其他场景，不得使用基础级电子签名认证证书。实际业务场景、使用目的或风险情况发生变化时，订户应核对现有证书是否仍然适用，不得继续使用与实际业务场景不匹配的证书。因订户超出证书规定用途、等级或适用场景使用证书产生的责任和损失，由订户自行承担。</p>
        <p>2. 订户应确保其应用系统能为数字证书提供安全的应用环境，若因网络、主机、操作系统或其他软硬件环境等存在安全漏洞，由此导致的安全事故及相关后果，豸信CA不承担责任。</p>
        <p>3. 订户应合法使用豸信CA 发放的数字证书，并对使用数字证书的行为负责：</p>
        <ul>
          <li>（1） 使用证书的行为应符合全部适用的法律法规，不得用于婚姻、收养、继承等人身关系事项、停止供水、供热、供气等公用事业服务事项，以及法律、行政法规或CPS规定的其他不适用电子签名的场景；</li>
          <li>（2） 使用证书的行为应符合订户真实意愿或者仅为了处理已获得授权的事务；</li>
          <li>（3） 使用证书的行为应符合本协议和CPS规定的用途、证书等级、适用范围和条件；非电子签名认证证书不得用于电子签名。</li>
        </ul>
        <p>4. 订户应采取必要措施，防止自行持有的硬件介质、签名私钥及激活数据丢失、泄露、篡改或被未经授权使用；应妥善保管用于身份验证和签名授权的口令、验证码等信息，不得泄露或交付无权人员。如订户因故意或过失导致证书或签名私钥遭盗用、冒用、伪造或者篡改，订户应自行承担相应责任。</p>
        <p>5. 签名私钥由订户本人或者机构订户的法定代表人、有效授权的受托人依约授权使用。使用豸信CA受托保管的签名私钥时，订户每次使用均应通过身份验证和签名授权方式作出明确授权；通过该等方式验证后实施的电子签名，视为订户的电子签名。所有使用证书在网络上签署电子文书或进行其他活动，均视为订户所为，因此产生的相关后果由订户自行承担。</p>
        <p>6. 如签名私钥、激活数据或用于身份验证、签名授权的密码、验证码等信息泄露、丢失，发现证书被不当使用，或者订户不希望继续使用证书、订户主体不存在，订户或其法定权利人应立即停止相关使用，向豸信CA申请撤销证书，办理手续遵循CPS。</p>
        <p>7. 数字证书一律不得转让、转借或转用。因转让、转借或转用而产生的相关后果应当由订户自行承担。</p>
        <p>8. 证书有效期自签发之日起计算，具体起止时间以证书记载为准。证书有效期届满或者被撤销后，不得继续使用该证书及对应签名私钥。</p>
        <p>9. 订户未与豸信CA约定证书服务费的，无须支付证书费用；若订户与豸信CA约定证书服务费的，订户有按约定缴纳数字证书服务费的义务，一旦订户接受数字证书，如果订户在证书服务期内退出数字证书服务体系，豸信CA 将不退还剩余时间的服务费用。</p>
        <p>10. 硬件介质（UKey）保质期为一年。</p>
        <h2>第六条 续期 密钥更新与证书变更</h2>
        <p>1. 证书有效期届满前仍需继续使用的，订户应按照CPS申请续期；需要更换签名密钥对的，应申请密钥更新；证书中的名称或其他可变更信息发生变化的，应及时申请证书变更。订户或其受托人应按照CPS配合完成相应查验及办理手续。逾期未办理，或者继续使用信息不准确、已失效或不适用的证书，由此产生的相关后果由订户自行承担。</p>
        <p>2. 豸信CA有权因安全风险因素要求订户更新签名密钥对或更换证书。订户收到通知后，应在规定期限内按照CPS办理。逾期未办理的，所引起的后果由订户自行承担。</p>
        <h2>第七条 撤销</h2>
        <p>1. 如签名私钥或激活数据泄露、丢失，证书中的信息发生重大变化，或者订户不希望继续使用证书，订户应立即向豸信CA申请撤销证书。撤销手续遵循CPS。订户应承担在证书撤销前因使用证书造成的相关责任。</p>
        <p>2. 如果自然人订户死亡，或者机构订户主体资格灭失（如企业注销等），订户的法定权利人、法定代表人或授权代表应立即向CA 机构请求撤销订户证书，订户主体及相关责任人应当承担其数字证书在撤销前所有因使用数字证书而造成的相关后果。</p>
        <p>3. 订户知悉，如果豸信CA 发现了订户证书的不当使用，或者订户证书被用于违法甚至犯罪行为，豸信CA 有权直接撤销订户证书。</p>
        <p>4. 证书一旦被撤销，订户不得继续使用该证书及对应签名私钥。</p>
        <p>5. 对于下列情形之一，豸信CA 有权主动撤销所签发的证书：</p>
        <ul>
          <li>（1） 订户申请证书时提供不真实、不完整或不准确的信息或资料；</li>
          <li>（2） 证书对应的私钥泄露或出现其他证书的安全性得不到保证的情况；</li>
          <li>（3） 订户不能履行或违反了相关法律、法规和本协议所规定的责任和义务；</li>
          <li>（4） 法律法规或CPS规定的其他应予撤销的情形。</li>
        </ul>
        <p>6. 证书撤销不免除订户对撤销前证书使用行为应承担的责任，不当然影响撤销前已发生的电子签名及相关文书的效力。</p>
        <h2>第八条 责任承担</h2>
        <p>1. 订户损害豸信CA 利益的，须向豸信CA 赔偿全部损失。这些情形包括但不限于：</p>
        <ul>
          <li>（1） 订户在申请数字证书时没有提供真实、完整、准确信息，或在这些信息变更时未及时通知豸信CA；</li>
          <li>（2） 未能保护订户自行持有的签名私钥、激活数据或用于身份验证、签名授权的信息，未采取必要防护措施，导致遗失、泄露、篡改或被未经授权使用；</li>
          <li>（3） 订户知悉签名私钥已经失密或者可能失密，未及时告知有关各方并终止使用；</li>
          <li>（4） 订户如果向依赖方传递信息时表述有误，而依赖方用证书验证了一个或多个数字签名后理所当然地相信这些表述，订户必须对这种行为的后果负责；</li>
          <li>（5） 证书的非法使用，即违反豸信CA 对证书使用的规定，造成了豸信CA 或有关各方的利益受到损失；</li>
          <li>（6） 订户有其他过错或未履行本协议的相关约定。</li>
        </ul>
        <p>2. 如果订户依法使用豸信CA 提供的认证服务进行民事活动而遭受损失的，豸信CA 将给予相应赔偿，除非豸信CA 能够证明其提供的服务是按照《电子签名法》等相关法律法规和豸信CA 向主管部门备案的 CPS 实施的。以下损失不在豸信CA 进行赔偿之列：</p>
        <ul>
          <li>（1） 任何直接或间接的利润或收入损失、信誉或商誉损害、任何商机或契机损失、失去项目、以及失去或无法使用任何数据、无法使用任何设备、无法使用任何软件；</li>
          <li>（2） 由上述损失相应生成或附带引起的损失或损害。</li>
        </ul>
        <p>3. 以下损失豸信CA 将不承担责任：</p>
        <ul>
          <li>（1） 非因豸信CA 的行为而导致的损失；</li>
          <li>（2） 因意外事件或不可抗力而导致的损失，如罢工、战争、灾害、恶意代码病毒等。</li>
        </ul>
        <p>4. 豸信CA对机构电子签名认证证书的赔偿上限为人民币贰仟元整（￥2000元）；对个人电子签名认证证书的赔偿上限为人民币肆佰元整（￥400元）。</p>
        <h2>第九条 其他</h2>
        <p>1. 豸信CA有权对本协议进行修订，修订后的协议将在豸信CA官网<a href="https://www.zxca.cn">（www.zxca.cn）</a>公示。订户在修订后的协议公示一周后继续使用豸信CA证书服务，即表明同意接受修订后的协议约束。订户不接受修订内容的，可以在上述期限内以书面形式向豸信CA申请停止使用证书。</p>
        <p>2. 本协议适用中华人民共和国法律。因本协议产生的纠纷或争议，双方应先友好协商；协商不成的，任何一方均可向豸信CA住所地有管辖权的人民法院提起诉讼。</p>
        <p>3. 您确认已经认真阅读并完全理解本协议各项规定。本协议可以通过网络申请界面点击同意、回填短信验证码确认、使用电子签名签署或者书面签署等各类方式接受；您作出上述接受行为时，本协议即时生效。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.agreementBody {
  background: #f1f3f7;
}
.agreementMain {
  width: 1600px;
  margin: 16px auto 0;
  padding: 32px;
  background: #fff;
  color: #333;
  h1{
    font-size: 24px;
    text-align: center;
    padding-bottom: 32px;
  }
  h2 {
    font-size: 18px;
    text-align: center;
    padding: 32px 0;
  }
  p{
    text-indent: 2em;
    line-height: 24px;
  }
  ul{
    margin-left: 70px;
    text-indent: 2em;
    line-height: 24px;
    list-style: none;
    padding-left: 0;
    li{
      list-style-position:inherit;
    }
  }
}
</style>
